/**
 * Takes a devcode method and provides a single string 'ID' for use
 * as DevCode does not have a concept of unique IDs per method/type/service.
 */
function getMethodIdentifier({ txType, service, providerType }) {
    return `${txType}_${service || 'none'}_${providerType || 'none'}`;
}
/**
 * Checks if the ID matches the method given (case insenstive)
 */
function isMatchingId(id, method) {
    return id?.toLowerCase() === getMethodIdentifier(method).toLowerCase();
}
/**
 * Creates an id (lowercase) => method mapping object
 */
function createMethodMap(methods) {
    return methods.reduce((all, method) => {
        const id = getMethodIdentifier(method).toLowerCase();
        all[id] = method;
        return all;
    }, {});
}

export { createMethodMap, getMethodIdentifier, isMatchingId };
